import styled from "styled-components";
import colorPalette from "@streeteasy/design-system/deprecated/colors";

const AreaSelectorMapDiv = styled.div`
  height: 100%;
  position: relative;
  width: 100%;
`;

const AreaSelectorContainer = styled.div`
  background-color: ${colorPalette.pureWhite};
  display: flex;
  height: auto;
  justify-content: center;
  overflow: hidden;
  width: 980px;
`;

const MapContainer = styled.div`
  flex-basis: 33.33%;
  padding: 15px 0 15px 15px;
`;

const CheckBoxContainer = styled.div`
  flex-basis: 66.66%;
  padding: 15px;
`;

const BoroughTabContainer = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
`;

AreaSelectorMapDiv.displayName = "AreaSelectorMapDiv";
AreaSelectorContainer.displayName = "AreaSelectorContainer";
MapContainer.displayName = "MapContainer";
CheckBoxContainer.displayName = "CheckBoxContainer";
BoroughTabContainer.displayName = "BoroughTabContainer";

export {
  AreaSelectorMapDiv,
  AreaSelectorContainer,
  MapContainer,
  CheckBoxContainer,
  BoroughTabContainer
};
